import { render, staticRenderFns } from "./MarketOverallOverview.component.vue?vue&type=template&id=3c27fac0&scoped=true"
import script from "./MarketOverallOverview.component.vue?vue&type=script&lang=js"
export * from "./MarketOverallOverview.component.vue?vue&type=script&lang=js"
import style0 from "./MarketOverallOverview.component.vue?vue&type=style&index=0&id=3c27fac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27fac0",
  null
  
)

export default component.exports